import { api_stuOrderWearState, api_schoolEduCampusStarRule } from '@/api/javaApi'

const resource = {
    state: {
        storeRoute: null,
        picBaseUrl: 'https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/',
        // 伴学精灵 / 形象 0
        spriteUrl: '',
        // 提示词
        cueWord: '',
        // 头像 3
        imageUrl: '',
        // 头像挂件 1
        titleUrl: '',
        // OSS对象
        stsClientOss: null,
    },
    mutations: {
        SET_picBaseUrl(state, data) {
            state.picBaseUrl = data
        },
        SET_spriteUrl(state, data) {
            state.spriteUrl = data ? state.picBaseUrl + data : '';
        },
        SET_imageUrl(state, data) {
            state.imageUrl = data ? state.picBaseUrl + data : '';
        },
        SET_titleUrl(state, data) {
            state.titleUrl = data ? state.picBaseUrl + data : '';
        },
        SET_cueWord(state, data) {
            state.cueWord = data;
        },
        SET_STOREROUTE(state, data) {
            state.storeRoute = data;
        },
        SET_STS_CLIENT_OSS(state, data) {
            state.stsClientOss = data;
        },
    },
    actions: {
        getStuTitleUrl(store) {
            // console.log('store:', store)
            store.commit('SET_imageUrl', '')
            store.commit('SET_titleUrl', '')
            store.commit('SET_cueWord', '')
            // identity 1老师 2学生
            if (store.rootState.user.identity === 1) return false;
            if (!store.rootState.user.userInfo.id) return false;
            api_stuOrderWearState({ stuId: store.rootState.user.userInfo.id }).then(res => {
                res.forEach(item => {
                    if (item.category === 0) {
                        store.commit('SET_spriteUrl', item.pictureUrl)
                        store.commit('SET_cueWord', item.cueWord)
                    }
                    if (item.category === 3) {
                        store.commit('SET_imageUrl', item.pictureUrl)
                    }
                    if (item.category === 1) {
                        store.commit('SET_titleUrl', item.pictureUrl)
                    }
                })
            })
        },
        /**
         * 星币发放规则
         * @param {*} store 
         * @param {eduCampusId,ruleType} params 
         * @returns 
         */
        async schoolEduCampusStarRule(store, params) {
            console.log(store)
            return api_schoolEduCampusStarRule(params);
        }
    }
}
export default resource